// ─── Coach-set nutrition targets (member side) ───
// `useNutritionGoals(s.goals)` gives the day's goals: the coach's targets when set, the
// member's own goals otherwise (never written back). Refreshed on the
// `nutrition_targets` org ping and on foreground. API: my_nutrition_targets.
import React, { useMemo } from 'react';
import { V } from '../utils/theme';
import { Icons } from './Icons';
import { useOrgFeed } from '../utils/orgFeed';
import { NUTRITION_TARGETS_CACHE_KEY, effectiveGoals, hasTargets, targetsSource } from '../utils/nutritionTargets';

export function useNutritionGoals(own) {
  const { data } = useOrgFeed('my_nutrition_targets', { kind: 'nutrition_targets', cacheKey: NUTRITION_TARGETS_CACHE_KEY });
  const targets = data && hasTargets(data.targets) ? data.targets : null;
  const coach = targets ? data.coach || null : null;
  const { goals, coachKeys } = useMemo(() => effectiveGoals(own, targets), [own, targets]);
  return { goals, targets, coach, coachKeys };
}

// "Set by Sam C." with the coach's note; nothing when the member's own goals apply.
export function CoachTargetsNote({ nt, compact = false }) {
  if (!nt || !nt.targets) return null;
  const note = typeof nt.targets.note === 'string' ? nt.targets.note.trim() : '';
  return (
    <div data-testid="coach-targets-note" style={{ display: 'flex', alignItems: 'flex-start', gap: 6, marginTop: compact ? 8 : 12,
      paddingTop: compact ? 6 : 8, paddingBottom: compact ? 6 : 8, paddingLeft: 10, paddingRight: 10, borderRadius: 10,
      background: `${V.accent}0d`, border: `1px solid ${V.accent}26` }}>
      <span aria-hidden="true" style={{ marginTop: 1, flexShrink: 0 }}>{Icons.target({ size: 13, color: V.accent })}</span>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: V.accent }}>{targetsSource(nt.coach)}</div>
        {note && !compact && <div style={{ fontSize: 12, color: V.text2, lineHeight: 1.45, marginTop: 2, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{note}</div>}
        {note && compact && <div style={{ fontSize: 11, color: V.text3, marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{note}</div>}
      </div>
    </div>
  );
}
